import types from '../mutation-types';
import LLMChatbotApi from '../../api/llm_chatbots';
import InteractionHistoryApi from '../../api/interaction_histories';
import CallLogsAPI from '../../api/call_logs';

export const state = {
  llm_models: [],
  llm_bots: [],
  uiFlags: {
    isModelFetching: false,

    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,

    isFetchingById: false,

    isLLMFetching: false,
    isCallInboxFetching: false,
    isCallReportFetching: false,
    isCallReportByLLMIDFetching: false,

    isTwilioCallReportFetching: false,
  },
  llm_assistants: [],
  callInboxes: [],

  // reports
  agent_call_reports: [],
  agent_call_meta: {
    count: 0,
    current_page: 1,
    page_size: 15,
    reports: {
      success: 0,
      failure: 0,
      unknown: 0,
      total_cost: 0,
      total_duration: 0,
    },
  },

  // twilio_call_reports:[],
  // twilio_call_meta: {
  //     count: 0,
  //     current_page: 1,
  //     page_size: 15,
  //     reports: {
  //         success: 0,
  //         failure: 0,
  //         unknown: 0,
  //         total_cost: 0,
  //         total_duration: 0,
  //         recipient: 0,
  //     }
  // },
};

// list of getters
const getters = {
  getLLModels(_state) {
    return _state.llm_models;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getLLMBots(_state) {
    return _state.llm_bots;
  },
  getLLMBotById: _state => id => {
    return _state.llm_bots.find(llm_bot => llm_bot.id === id);
  },

  // llm assistants
  getLLMAssistants(_state) {
    return _state.llm_assistants;
  },
  getCallInboxes(_state) {
    return _state.callInboxes;
  },

  // reports
  getAgentCallReports(_state) {
    return _state.agent_call_reports;
  },
  getAgentCallMeta(_state) {
    return _state.agent_call_meta;
  },

  // getTwilioCallReports(_state){
  //     return _state.twilio_call_reports;
  // },
  // getTwilioCallMeta(_state){
  //     return _state.twilio_call_meta;
  // },
};

// actions list
const actions = {
  fetchLLMModels: async function({ commit, state }) {
    commit(types.SET_LLMBOTS_UI_FLAG, { isModelFetching: true });
    try {
      const { data } = await LLMChatbotApi.getLLMModels();
      commit(types.SET_LLM_MODEL_LIST, data?.data || []);
      commit(types.SET_LLMBOTS_UI_FLAG, { isModelFetching: false });
    } catch (error) {
      console.log(error);
      commit(types.SET_LLMBOTS_UI_FLAG, { isModelFetching: false });
      throw error;
    }
  },
  fetchLLMBots: async function({ commit, state }) {
    commit(types.SET_LLMBOTS_UI_FLAG, { isFetching: true });
    try {
      const { data } = await LLMChatbotApi.getAllLLMChatbots();
      commit(types.SET_LLMBOTS_LIST, data?.data || []);
      commit(types.SET_LLMBOTS_UI_FLAG, { isFetching: false });
    } catch (error) {
      console.log(error);
      commit(types.SET_LLMBOTS_UI_FLAG, { isFetching: false });
      throw error;
    }
  },

  fetchLLMBotById: async function({ commit, state }, { llm_id }) {
    commit(types.SET_LLMBOTS_UI_FLAG, { isFetchingById: true });
    try {
      const { data } = await LLMChatbotApi.fetchLLMByid(llm_id);
      commit(types.SET_LLMBOT_BY_ID, data);
      commit(types.SET_LLMBOTS_UI_FLAG, { isFetchingById: false });
    } catch (error) {
      console.log(error);
      commit(types.SET_LLMBOTS_UI_FLAG, { isFetchingById: false });
      throw error;
    }
  },

  createLLMbot: async function({ commit, state }, payload) {
    commit(types.SET_LLMBOTS_UI_FLAG, { isCreating: true });
    try {
      const { data } = await LLMChatbotApi.createLLMChatbot(payload);
      commit(types.SET_LLM_BOT_CREATE, data);
      commit(types.SET_LLMBOTS_UI_FLAG, { isCreating: false });
      // return data;
    } catch (error) {
      console.log(error);
      commit(types.SET_LLMBOTS_UI_FLAG, { isCreating: false });
      throw error;
    }
  },
  updateLLMbotById: async function({ commit, state }, { llm_bot_id, payload }) {
    commit(types.SET_LLMBOTS_UI_FLAG, { isUpdating: true });
    try {
      const { data } = await LLMChatbotApi.updateLLMChatbot(
        llm_bot_id,
        payload
      );
      commit(types.SET_LLM_BOT_UPDATE, { llm_bot_id, payload: data });
      commit(types.SET_LLMBOTS_UI_FLAG, { isUpdating: false });
      // return data;
    } catch (error) {
      console.log(error);
      commit(types.SET_LLMBOTS_UI_FLAG, { isUpdating: false });
      throw error;
    }
  },
  deleteLLMbotById: async function({ commit, state }, { llm_bot_id }) {
    commit(types.SET_LLMBOTS_UI_FLAG, { isDeleting: true });
    try {
      const { data } = await LLMChatbotApi.deleteLLMChatbot(llm_bot_id);
      commit(types.SET_LLM_BOT_DELETE, llm_bot_id);
      commit(types.SET_LLMBOTS_UI_FLAG, { isDeleting: false });
      // return data;
    } catch (error) {
      console.log(error);
      commit(types.SET_LLMBOTS_UI_FLAG, { isDeleting: false });
      throw error;
    }
  },

  fetchLLMAssistants: async function({ commit, state }, query = {}) {
    commit(types.SET_LLMBOTS_UI_FLAG, { isLLMFetching: true });
    try {
      const { data } = await LLMChatbotApi.getLLMAssistantList(query);
      commit(types.SET_LLM_ASSISTANT_LIST, data);
      commit(types.SET_LLMBOTS_UI_FLAG, { isLLMFetching: false });
    } catch (error) {
      console.log(error);
      commit(types.SET_LLMBOTS_UI_FLAG, { isLLMFetching: false });
      throw error;
    }
  },

  fetchCallInboxed: async function({ commit, state }) {
    commit(types.SET_LLMBOTS_UI_FLAG, { isCallInboxFetching: true });
    try {
      const { data } = await LLMChatbotApi.fetchLLmCallInboxes();
      commit(types.SET_LLM_CALL_INBOX_LIST, Array.isArray(data) ? data : []);
      commit(types.SET_LLMBOTS_UI_FLAG, { isCallInboxFetching: false });
    } catch (error) {
      console.log(error);
      commit(types.SET_LLMBOTS_UI_FLAG, { isCallInboxFetching: false });
      throw error;
    }
  },

  fetchAgentCallReport: async function({ commit, state }, query) {
    commit(types.SET_LLMBOTS_UI_FLAG, { isCallReportFetching: true });
    try {
      const response = await InteractionHistoryApi.fetchAgentInteactionHistory(
        query
      );
      const newData = response.data?.data || [];
      const meta = {
        ...state.agent_call_meta,
        ...(response.data?.meta || {}),
      };

      // if page = 1, make empty the list
      if (query.page === 1) {
        commit(types.SET_LLM_CALL_REPORTS, newData);
      } else {
        // Append to existing list
        const combined = [...state.agent_call_reports, ...newData];
        commit(types.SET_LLM_CALL_REPORTS, combined);
      }
      // Save pagination metadata
      commit(types.SET_LLM_CALL_REPORTS_META, meta);

      // commit(types.SET_LLM_CALL_REPORTS, response.data?.data || []);
      // commit(types.SET_LLM_CALL_REPORTS, agentCostsDummy);
      commit(types.SET_LLMBOTS_UI_FLAG, { isCallReportFetching: false });
    } catch (error) {
      console.log(error);
      commit(types.SET_LLMBOTS_UI_FLAG, { isCallReportFetching: false });
    }
  },
  getAgentInteractionHistoryFilterList: async function(
    { commit, state },
    query
  ) {
    commit(types.SET_LLMBOTS_UI_FLAG, { isCallReportFetching: true });
    try {
      const response = await InteractionHistoryApi.getAgentInteractionHistoryFilterList(
        query
      );
      const newData = response.data?.data || [];
      const meta = {
        ...state.agent_call_meta,
        ...(response.data?.meta || {}),
      };

      // if page = 1, make empty the list
      if (query.page === 1) {
        commit(types.SET_LLM_CALL_REPORTS, newData);
      } else {
        // Append to existing list
        const combined = [...state.agent_call_reports, ...newData];
        commit(types.SET_LLM_CALL_REPORTS, combined);
      }
      // Save pagination metadata
      commit(types.SET_LLM_CALL_REPORTS_META, meta);

      // commit(types.SET_LLM_CALL_REPORTS, response.data?.data || []);
      // commit(types.SET_LLM_CALL_REPORTS, agentCostsDummy);
      commit(types.SET_LLMBOTS_UI_FLAG, { isCallReportFetching: false });
    } catch (error) {
      console.log(error);
      commit(types.SET_LLMBOTS_UI_FLAG, { isCallReportFetching: false });
    }
  },

  // fetchTwilioCallReport: async function({commit,state},query){
  //     commit(types.SET_LLMBOTS_UI_FLAG,{isTwilioCallReportFetching: true});
  //     try {
  //         const response = await CallLogsAPI.getTwilioCallReport(query);
  //         const newData = response.data?.data || [];
  //         const meta = {
  //             ...state.twilio_call_meta,
  //             ...(response.data?.meta || {})
  //         };

  //          // if page = 1, make empty the list
  //         if (query.page === 1) {
  //             commit(types.SET_TWILIO_CALL_REPORTS, newData);
  //         }else{
  //              // Append to existing list
  //             const combined = [...state.twilio_call_reports, ...newData];
  //             commit(types.SET_TWILIO_CALL_REPORTS, combined);
  //         }
  //          // Save pagination metadata
  //         commit(types.SET_TWILIO_CALL_REPORTS_META, meta);

  //         commit(types.SET_LLMBOTS_UI_FLAG,{isTwilioCallReportFetching: false});
  //     } catch (error) {
  //         console.log(error);
  //         commit(types.SET_LLMBOTS_UI_FLAG,{isTwilioCallReportFetching: false});
  //     }
  // },
};

// list of mutations
const mutations = {
  // mutate UI flags
  [types.SET_LLMBOTS_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_LLM_MODEL_LIST]($state, data) {
    $state.llm_models = data;
  },

  // create a llmbot
  [types.SET_LLM_BOT_CREATE]($state, data) {
    $state.llm_bots.unshift(data);
  },
  [types.SET_LLMBOTS_LIST]($state, data) {
    $state.llm_bots = data;
  },
  [types.SET_LLM_CALL_INBOX_LIST]($state, data) {
    $state.callInboxes = data;
  },

  [types.SET_LLM_BOT_UPDATE]($state, { llm_bot_id, payload }) {
    const index = $state.llm_bots.findIndex(
      llm_bot => llm_bot.id === payload.id
    );
    if (index !== -1) {
      // Replace existing coupon
      $state.llm_bots.splice(index, 1, payload);
    } else {
      // If not found, add the new coupon
      // $state.llm_bots.push(payload);
    }
  },
  [types.SET_LLM_BOT_DELETE]($state, llm_bot_id) {
    const index = $state.llm_bots.findIndex(
      llm_bot => llm_bot.id === llm_bot_id
    );
    if (index !== -1) {
      $state.llm_bots.splice(index, 1);
    }
  },
  [types.SET_LLMBOT_BY_ID]($state, data) {
    const index = $state.llm_bots.findIndex(llm_bot => llm_bot.id === data.id);
    if (index !== -1) {
      // Replace existing bot
      $state.llm_bots.splice(index, 1, data);
    } else {
      // Add new bot to the list
      $state.llm_bots.push(data);
    }
  },

  [types.SET_LLM_ASSISTANT_LIST]($state, data) {
    $state.llm_assistants = data;
  },

  // llm call reports
  [types.SET_LLM_CALL_REPORTS]($state, data) {
    $state.agent_call_reports = data;
  },
  [types.SET_LLM_CALL_REPORTS_META]($state, meta) {
    $state.agent_call_meta = {
      ...meta,
      count: meta.count || 0,
      current_page: meta.current_page || 1,
      page_size: meta.page_size || 15,
    };
  },
  // [types.SET_TWILIO_CALL_REPORTS]($state, data) {
  //     $state.twilio_call_reports = data;
  // },
  // [types.SET_TWILIO_CALL_REPORTS_META]($state, meta) {
  //     $state.twilio_call_meta = {
  //         ...meta,
  //         count: meta.count || 0,
  //         current_page: meta.current_page || 1,
  //         page_size: meta.page_size || 15
  //     };
  // },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
